import { render, staticRenderFns } from "./FGroupDecimal.vue?vue&type=template&id=04c1d360&"
import script from "./FGroupDecimal.vue?vue&type=script&lang=js&"
export * from "./FGroupDecimal.vue?vue&type=script&lang=js&"
import style0 from "./FGroupDecimal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports